import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import MailTemplateForm from "@/components/mail/MailTemplateForm.vue";
import { formRules } from "@/js/form_rules.js";
export default {
  components: {
    MailTemplateForm: MailTemplateForm
  },
  props: {
    shown: Boolean,
    template: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    placeholders: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    isValidAddress: function isValidAddress() {
      var _address$country;
      var address = this.form.address;
      return address.street && address.city && ((_address$country = address.country) === null || _address$country === void 0 ? void 0 : _address$country.id_country);
    }
  },
  data: function data(_this) {
    return {
      isSaving: false,
      form: {
        valid: false,
        template: _objectSpread({}, _this.template)
      },
      rules: formRules
    };
  },
  methods: {
    close: function close() {
      this.$refs.form.$refs.form.reset();
      this.$emit("close");
    },
    clickPlaceholder: function clickPlaceholder(item, callback) {
      callback(item.symbol);
    },
    save: function save(_ref) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var form, isValid, _this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              form = _ref.form;
              isValid = _this2.$refs.form.$refs.form.validate() && _this2.$refs.form.validateHtmlContent();
              if (isValid) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              _this2.isSaving = true;
              _this = _this2;
              _this2.$emit("save", _this2.form.template, function () {
                _this.$nextTick(function () {
                  return _this.$refs.form.$refs.form.reset();
                });
                _this.isSaving = false;
                _this.$emit("close");
              }, function () {
                _this.isSaving = false;
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};